import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { Router } from '@angular/router';
import { CuestionarioRespuestaDto } from 'src/app/dto/cuestionario-respuesta-dto';
import { EvaluacionDto } from 'src/app/dto/evaluacion-dto';
import { EvadocCuestionarioPregunta } from 'src/app/model/evadoc-cuestionario-pregunta';
import { EvadocEvaluacion } from 'src/app/model/evadoc-evaluacion';
import { EvadocCuestionarioPreguntaService } from 'src/app/services/evadoc-cuestionario-pregunta.service';
import { EvadocCuestionarioRespuestaService } from 'src/app/services/evadoc-cuestionario-respuesta.service';
import { EvadocCuestionarioService } from 'src/app/services/evadoc-cuestionario.service';
import { VerificacionService } from 'src/app/services/verificacion.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-cuestionario',
  templateUrl: './cuestionario.component.html',
  styleUrls: ['./cuestionario.component.css']
})
export class CuestionarioComponent implements OnInit {

  uid: number = 0;
  public preg: number = 0;
  public load: boolean;
  info: EvadocEvaluacion;
  opcion: string;
  valueTextArea = '';
  pregunta: EvadocCuestionarioPregunta[] = [];
  enviarCuestionario: CuestionarioRespuestaDto[] = [];
  DatosEvaluacion: EvaluacionDto = new EvaluacionDto();
  form: FormGroup;
  advertencias: string[];
  advertencia: string = "";
  textoDeInput: string = null;

  constructor(
    private dialogRef: MatDialogRef<CuestionarioComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public cuestionario: EvadocCuestionarioService,
    private preguntas: EvadocCuestionarioPreguntaService,
    private respuestas: EvadocCuestionarioRespuestaService,
    public datepipe: DatePipe,
  ) { this.load = false; }

  ngOnInit() {
    this.adjustDialogSize();
    setTimeout(() => {
      this.load = true;
    }, 4000);

    // TRAER TITULO DE CUESTIONARIO E INSTRUCCIONES
    let cues: number;
    let uidc: number = this.data.uid;

    this.cuestionario.ObtenerInstrucciones(uidc).subscribe(res => {
      this.info = res;
      cues = this.info.cuestionario.codigo;
      this.TraerPreguntas(cues);
      (err: HttpErrorResponse) => console.log('error');
      return this.info;
    });
  }

  private adjustDialogSize() {
    const width = window.innerWidth;
    if (width < 768) {
      // En móviles, casi pantalla completa pero con un pequeño margen
      this.dialogRef.updateSize('98vw', '98vh');
    } else if (width < 1200) {
      // En tablets o pantallas medianas
      this.dialogRef.updateSize('85vw', '85vh');
    } else {
      // En pantallas grandes, limitar el ancho máximo para mejor legibilidad
      this.dialogRef.updateSize('1000px', '80vh');
    }
  }

  // TRAER PREGUNTAS O ENUNCIADOS DEL CUESTIONARIO 
  TraerPreguntas(cues: number) {
    this.preguntas.ObtenerPreguntas(cues).subscribe(res => {
      this.pregunta = res.filter(element => {
        element.validar = 1;
        return element
      });

      (err: HttpErrorResponse) => console.log('error');
    })
  }

  // MÉTODO PARA MOSTRAR OBSERVACIÓN
  observar(pre: number) {
    const en = document.getElementById('txtObservacion' + pre);
    if (pre != null) {
      en.style.display = 'block';
    }
  }

  // MÉTODO PARA NO MOSTRAR OBSERVACIÓN
  Noobservar(pre: number) {
    const en = document.getElementById('txtObservacion' + pre);
    if (pre != null) {
      en.style.display = 'none';
    }
  }

  public isSubmitting: boolean = false;

  // MÉTODO PARA GUARDAR CUESTIONARIO
  GuardarRespuestas(id: number): void {
    if (this.isSubmitting) {
      return;
    }
    this.isSubmitting = true;

    let periodo: number = this.data.periodo;
    let docente: number = this.data.docente;
    let curso: number = this.data.curso;
    let tipo: number = this.data.uid;

    if (this.info.cuestionario.codigo == 3) {
      tipo = 2;
    } else if (this.info.cuestionario.codigo == 2) {
      tipo = 3;
    } else if (this.info.cuestionario.codigo == 1) {
      tipo = 1;
    }

    this.DatosEvaluacion.docente = docente;
    this.DatosEvaluacion.evaludaor = JSON.parse(atob(sessionStorage.getItem(environment.tokenName).split(".")[1])).user_name;
    this.DatosEvaluacion.periodo = periodo;
    this.DatosEvaluacion.observacion = this.textoDeInput;
    this.DatosEvaluacion.cuestionario = this.info.cuestionario.codigo;
    this.DatosEvaluacion.tipoEvaluador = tipo;
    //this.info.evadocTipoEvaluador.codigo;
    this.DatosEvaluacion.curso = curso;
    this.DatosEvaluacion.lstCuestionarioRespuestaDto = this.enviarCuestionario;

    let res = true
    this.advertencias = [];
    this.enviarCuestionario.map((item, index) => {

      if (item.respuesta <= 5 && (item.observacionR == '' || item.observacionR == null || item.observacionR.length < 10)) {
        let texto: string = "" + (index + 1);
        res = false
        this.advertencias.push(texto);
        this.advertencia = "Observación inválida en la(s) pregunta(s) " + this.advertencias.toString() + ". Debe tener al menos 10 caracteres.";
      }
    })

    if (this.textoDeInput && this.textoDeInput.length > 0 && this.textoDeInput.length < 10) {
      res = false;
      this.advertencia = "La observación opcional debe tener al menos 10 caracteres si desea enviarla.";
    }

    if (res && this.DatosEvaluacion.lstCuestionarioRespuestaDto.length != 0 && this.DatosEvaluacion.lstCuestionarioRespuestaDto.length == this.pregunta.length) {
      this.respuestas.GuardarRespuesta(this.DatosEvaluacion).subscribe((res) => {   // Aquí se inserta evaluacion!
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: '¡Cuestionario Enviado!',
          showConfirmButton: false,
          timer: 1500
        });
        this.dialogRef.close();
      }, (error) => {
        this.isSubmitting = false;
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo guardar la evaluación. Intente nuevamente.'
        });
      });
    }
    else {
      this.isSubmitting = false;

      if (this.DatosEvaluacion.lstCuestionarioRespuestaDto.length != 0 && this.DatosEvaluacion.lstCuestionarioRespuestaDto.length == this.pregunta.length) {
        Swal.fire({
          position: 'top-end',
          icon: 'warning',
          title: 'Error al enviar cuestionario',
          text: this.advertencia,
          showConfirmButton: false,
          timer: 4000
        })
      } else {
        Swal.fire({
          position: 'top-end',
          icon: 'warning',
          title: '¡Error al enviar cuestionario!',
          text: "Faltan preguntas por contestar.",
          showConfirmButton: false,
          timer: 4000
        })
      }
    }
  }

  // MÉTODO PARA OBTENER VALORES 
  Obtener(valorRadio, CodPregunta, item) {
    let valid: number = this.pregunta.indexOf(item);
    this.pregunta[valid].validar = 0;
    let index = this.enviarCuestionario.findIndex(e => e.pregunta === CodPregunta)

    if (index >= 0) {
      this.enviarCuestionario.splice(index, 1)
    }

    const informa = new CuestionarioRespuestaDto();
    informa.pregunta = CodPregunta;
    informa.respuesta = parseInt(valorRadio);
    this.enviarCuestionario.push(informa);
  }

  // MÉTODO PARA OBTENER VALORES DEL TEXTAREA
  changeValueTextArea(valorRadio, CodPregunta) {
    let index = this.enviarCuestionario.findIndex(e => e.pregunta === CodPregunta)
    if (index >= 0) {
      this.enviarCuestionario[index].observacionR = valorRadio.target.value;
    }
  }
}
